import api from '../../utils/api';
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Spinner } from '../../components/ui';

const ADMIN_WA = '919443724724';

export default function ForgotPassword() {
  const [phone, setPhone] = useState('');
  const [sent, setSent] = useState(false);

  const handleWhatsApp = async () => {
    if (!phone || phone.replace(/\D/g,'').length < 10) {
      alert('Please enter your 10-digit registered phone number');
      return;
    }
    const clean = phone.replace(/\D/g,'').slice(-10);
    // Save request to DB so admin sees it in Pwd Requests tab
    try { await api.post('/auth/forgot-password-request', { phone: clean }); } catch {}
    const msg = `Hi, I forgot my TNPSC Hub password.\nRegistered Phone: ${clean}\nPlease help me reset my password.`;
    window.open(`https://wa.me/${ADMIN_WA}?text=${encodeURIComponent(msg)}`, '_blank');
    setSent(true);
  };

  return (
    <div style={{ minHeight:'100vh', background:'linear-gradient(145deg,#f0f4ff,var(--bg))', display:'flex', alignItems:'center', justifyContent:'center', padding:24, fontFamily:'var(--font-body)' }}>
      <div style={{ width:'100%', maxWidth:460 }}>

        {/* Logo */}
        <div style={{ textAlign:'center', marginBottom:36 }}>
          <Link to="/" style={{ display:'inline-flex', alignItems:'center', gap:10, textDecoration:'none' }}>
            <div style={{ width:44, height:44, background:'linear-gradient(135deg,var(--blue),var(--blue-mid))', borderRadius:12, display:'flex', alignItems:'center', justifyContent:'center', fontSize:20 }}>🏆</div>
            <span style={{ fontFamily:'var(--font-heading)', fontSize:24, fontWeight:700, color:'var(--blue)' }}>TNPSC <span style={{ color:'var(--gold)' }}>Hub</span></span>
          </Link>
        </div>

        <div className="card" style={{ animation:'scaleIn 0.35s ease' }}>
          <div className="card-body" style={{ padding:36 }}>

            {!sent ? (<>
              {/* Icon + Title */}
              <div style={{ textAlign:'center', marginBottom:28 }}>
                <div style={{ width:64, height:64, borderRadius:'50%', background:'rgba(37,211,102,0.1)', border:'2px solid rgba(37,211,102,0.3)', display:'flex', alignItems:'center', justifyContent:'center', fontSize:28, margin:'0 auto 16px' }}>📲</div>
                <h2 style={{ fontFamily:'var(--font-heading)', fontSize:24, marginBottom:8 }}>Forgot Password?</h2>
                <p style={{ color:'var(--muted)', fontSize:13, lineHeight:1.6 }}>Contact admin on WhatsApp to reset your password instantly.</p>
              </div>

              {/* Steps */}
              <div style={{ background:'var(--bg2)', borderRadius:12, padding:16, marginBottom:24 }}>
                <div style={{ fontWeight:700, color:'var(--blue)', marginBottom:10, fontSize:13 }}>How it works:</div>
                {[
                  '1️⃣ Enter your registered phone number',
                  '2️⃣ Click the WhatsApp button below',
                  '3️⃣ Send the pre-filled message to admin',
                  '4️⃣ Admin resets & sends your new password',
                  '5️⃣ Login with new password ✅',
                ].map(s => <div key={s} style={{ fontSize:13, color:'var(--text)', marginBottom:5 }}>{s}</div>)}
              </div>

              {/* Input */}
              <div className="form-group">
                <label className="form-label">📞 Registered Phone Number</label>
                <div className="input-wrap">
                  <span className="input-icon">📱</span>
                  <input className="form-input" type="tel" maxLength={10} placeholder="Enter 10-digit phone number"
                    value={phone} onChange={e => setPhone(e.target.value.replace(/\D/g,''))}
                    onKeyDown={e => e.key === 'Enter' && handleWhatsApp()} autoFocus />
                </div>
              </div>

              <button onClick={handleWhatsApp}
                style={{ width:'100%', padding:14, background:'#25D366', color:'#fff', border:'none', borderRadius:12, fontSize:16, fontWeight:700, cursor:'pointer', display:'flex', alignItems:'center', justifyContent:'center', gap:10, marginBottom:12 }}>
                <span style={{ fontSize:20 }}>📲</span> Contact Admin on WhatsApp
              </button>

              <div style={{ textAlign:'center', fontSize:13, color:'var(--muted)' }}>
                Admin: <strong style={{ color:'#25D366' }}>+91 98427 24724</strong>
              </div>

            </>) : (<>
              {/* Success */}
              <div style={{ textAlign:'center' }}>
                <div style={{ fontSize:60, marginBottom:16 }}>✅</div>
                <h3 style={{ fontFamily:'var(--font-heading)', color:'var(--success)', margin:'0 0 12px' }}>WhatsApp Opened!</h3>
                <p style={{ color:'var(--muted)', fontSize:14, lineHeight:1.6 }}>
                  Send the message to admin. Admin will reset your password and reply on WhatsApp.
                </p>
                <div style={{ background:'rgba(37,211,102,0.08)', border:'1px solid rgba(37,211,102,0.2)', borderRadius:12, padding:14, margin:'20px 0', fontSize:13, color:'#1a7a4a', fontWeight:600 }}>
                  💡 Come back and login once you receive your new password!
                </div>
                <button onClick={() => setSent(false)}
                  style={{ background:'var(--bg2)', color:'var(--blue)', border:'none', borderRadius:10, padding:'10px 20px', fontSize:14, cursor:'pointer', fontWeight:600, width:'100%', marginBottom:8 }}>
                  🔄 Try Again
                </button>
              </div>
            </>)}

            <div style={{ textAlign:'center', marginTop:20 }}>
              <Link to="/login" style={{ fontSize:13, color:'var(--muted)' }}>← Back to Login</Link>
            </div>
          </div>
        </div>
      </div>
      <style>{`@keyframes scaleIn{from{opacity:0;transform:scale(0.94)}to{opacity:1;transform:scale(1)}}`}</style>
    </div>
  );
}
